import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Creators } from '../../../duck/actions';

import { createMarkup } from '../../../utils/utils';
import {
  ListElement,
  Content,
  AuthorAndTime,
  Image,
  FlexContainer,
  Title
} from '../../common/StyledComponents';
import { SideBar } from '../../common/StyledComponents/StyledSideBar';
import AdBanner from '../../common/AdBanner/AdBanner';
import OuterBox from '../../common/OuterBox/OuterBox';
import InnerBox from '../../common/InnerBox/InnerBox';
import RelatedArticles from '../../common/RelatedArticles/RelatedArticles';
import Comments from '../../common/Comments/Comments';
import adTissot from '../../../assets/images/ad-tissot.png';
import adSuggested from '../../../assets/images/ad-suggested.png';
import adAmazonVertical from '../../../assets/images/ad-amazon-vertical.png';
import adSeparator from '../../../assets/images/ad-separator.png';
import NoClickBannerDivision from '../../common/Banner/NoClickBannerDivision/NoClickBannerDivision';
import StickySpecsBar from '../../common/StickySpecsBar/StickySpecsBar';
import Specifications from '../../common/Specifications/Specifications';
import StickyHeader from '../../common/Navigation/StickyHeader/StickyHeader';
import goToTop from '../../../assets/images/gototop.png';
import SingleArticleLoader from '../../common/Loaders/SingleArticleLoader';
import Loader from '../../common/Loaders/Loader';

const handleGoToTop = () => {
  console.log('Came in Handle');
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

const scrollFunction = () => {
  // console.log('Came in Scroll Function');
  if (
    document.body.scrollTop > 800 ||
    document.documentElement.scrollTop > 800
  ) {
    document.getElementById('goToTopBtn').style.display = 'flex';
  } else {
    document.getElementById('goToTopBtn').style.display = 'none';
  }
};

class SingleReview extends Component {
  componentWillMount = () => {
    // console.log('[SingleReview.js] componentWillMount');
    // window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    // console.log('[SingleReview.js] CDM');
    // console.log('[SingleReview.js]\nthis.props: ', this.props);
    if (this.props.history.action === 'PUSH') {
      console.log('Came in CDM to scroll to Top');
      window.twttr.widgets.load();
      // window.scrollTo(0, 0);
    }

    let postSlug = this.props.location.pathname.slice(1);

    this.props.onFetchSingleReview(postSlug);

    window.addEventListener('scroll', scrollFunction);

    // if (this.props.topNews === null) {
    //   this.props.onFetchTopNews();
    // }
  };
  componentWillUnmount = () => {
    window.removeEventListener('scroll', scrollFunction);
  };

  componentDidUpdate = (prevProps, prevState) => {
    // console.log('componentDidUpdate: ');
    // console.log('prevProps: ', prevProps);
    // window.twttr.widgets.load();
    let postSlug = this.props.location.pathname.slice(1);
    let oldPostSlug = prevProps.location.pathname.slice(1);

    if (prevProps.history.action === 'PUSH' && postSlug !== oldPostSlug) {
      console.log('Came in CPUp to scroll to Top');
      // window.scrollTo(0, 0);
      this.props.onFetchSingleReview(postSlug);
    }
  };

  contentClickHandler = e => {
    // console.log('e: ', e);
    console.log('Content Click Handler');
    const targetLink = e.target.closest('a');
    // console.log('targetLink: ', targetLink);
    // console.log('targetLink: ', typeof targetLink);

    if (!targetLink) return;
    // console.log('targetLink: ', targetLink.getAttribute('data-ids'));
    e.preventDefault();
    e.stopPropagation();
    if (targetLink.pathname === '/old-gallery') {
      let oldGallerySlug = targetLink.getAttribute('data-ids');
      // console.log('oldGallerySlug: ', oldGallerySlug);
      this.props.history.push({
        pathname: targetLink.pathname.slice(1),
        state: `change`,
        oldGallerySlug: oldGallerySlug
      });
    } else if (targetLink.hostname === window.location.hostname) {
      // This is an Internal Link
      let x = targetLink.pathname;
      if (x.slice(-1) === '/') {
        x = x.slice(0, -1);
      }
      this.props.history.replace({ pathname: x, state: `change` });
    } else {
      // This is an External Link
      window.open(targetLink.href, '_blank');
    }

    console.log('targetLink.protocol: ', targetLink.protocol);
    console.log('targetLink.host: ', targetLink.host);
    console.log('targetLink.hostname: ', targetLink.hostname);
    console.log('targetLink.port: ', targetLink.port);
    console.log('targetLink.pathname: ', targetLink.pathname);
    console.log('targetLink.hash: ', targetLink.hash);
    console.log('targetLink.search: ', targetLink.search);
  };

  render() {
    const {
      // topNews,
      singleReview,
      relatedArticles,
      tagsList
      // error,
      // loading
      // onFetchSingleReview
    } = this.props;
    // console.log('relatedArticles: ', relatedArticles);
    // console.log('tagsList: ', tagsList);

    // Binding our scroll event handler
    window.onscroll = () => {
      // Fetch another SingleNews when current SingleNews reaches end.
      let page = document.getElementById('SingleReview');
      // console.log('page: ', page);
      let header = document.getElementById('Header');
      // console.log('header: ', header);
      if (page && window.scrollY > window.oldScroll && window.scrollY > 90) {
        header.classList.add('slide-out');
        header.classList.remove('slide-in');
      } else if (page && window.scrollY < window.oldScroll) {
        header.classList.add('slide-in');
        header.classList.remove('slide-out');
      }
      // console.log('window.oldScroll: ', window.oldScroll);
      // console.log('window.scrollY: ', window.scrollY);
      let specsHeader = document.getElementById('specs-header');
      // console.log('specsHeader: ', specsHeader);
      let specsHeaderFixed = document.getElementById('specs-header-fixed');
      console.log('Inside window.onscroll');
      try {
        if (specsHeader && window.scrollY < specsHeader.offsetTop) {
          specsHeader.style.visibility = 'visible';
          specsHeaderFixed.style.visibility = 'hidden';
        }
        if (
          (specsHeader && window.scrollY === specsHeader.offsetTop) ||
          window.scrollY > specsHeader.offsetTop
        ) {
          specsHeader.style.visibility = 'hidden';
          specsHeaderFixed.style.visibility = 'visible';
        }
      } catch (err) {
        window.oldScroll = window.scrollY;
        return;
      }
      window.oldScroll = window.scrollY;
    };

    let singlereview = null;
    if (singleReview) {
      singlereview = singleReview.map((review, index) => {
        // console.log('review: ', review);
        // timeStamp = review.date;
        return (
          <div
            key={review.id}
            className="SingleReview flex flex-column items-center"
            id="SingleReview"
          >
            {/* 1st division */}
            <AdBanner height="250px" width="970px" margin="18px 0">
              <Image
                src={adTissot}
                width="100%"
                height="100%"
                alt="tissot ad"
              />
            </AdBanner>

            {review.fimg_url ? (
              <NoClickBannerDivision
                // width="100%"
                url={review.fimg_url}
                title={review.title.rendered}
                subTitle={review.excerpt.rendered}
              />
            ) : (
              <Loader />
            )}

            <FlexContainer className="mt3 mh2 justify-center">
              <AdBanner height="91px" width="730px">
                <Image
                  src={adSeparator}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </FlexContainer>

            <OuterBox>
              <InnerBox>
                <ListElement padding="0px 5px 18px 5px">
                  <FlexContainer
                    alignitems="center"
                    className="AuthorImage AuthorImage PostDateTime Comments"
                    margin="0 0 0.5rem 0"
                  >
                    <Image
                      width="31px"
                      height="31px"
                      borderradius="50%"
                      src={review._embedded.author[0].avatar_urls[96]}
                      alt={review.user_meta.authorName}
                    />
                    <AuthorAndTime
                      fontFamily="Nunito"
                      fontWeight="bold"
                      color="#757575"
                      lineHeight="normal"
                      padding="0 0 0 10px"
                      className="w-100"
                      fontSize="0.875rem"
                    >
                      <Link to={`author/${review._embedded.author[0].slug}`}>
                        {review.user_meta.authorName}
                      </Link>
                      {/* <span>{review.user_meta.authorName}</span> */}
                      <span>{review.user_meta.postDate}</span>

                      {/* <div>{ review.authorName}</div> */}
                      {/* <div>{ review.authorName}</div> */}
                    </AuthorAndTime>
                  </FlexContainer>
                  {/* Content */}
                  {review && Object.keys(review).length ? (
                    <Content
                      id="content"
                      onClick={this.contentClickHandler}
                      dangerouslySetInnerHTML={createMarkup(
                        review.content.rendered
                      )}
                    />
                  ) : (
                    <Loader />
                  )}
                </ListElement>
                <SideBar>
                  <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
                    <Image
                      src={adAmazonVertical}
                      width="300px"
                      height="100%"
                      alt="tissot ad"
                    />
                  </AdBanner>
                </SideBar>
              </InnerBox>
            </OuterBox>

            {/* 2nd division */}
            {review.acf && review.acf.specifications && review.acf.key_specs ? (
              <OuterBox className="flex-column items-center w-100">
                <StickySpecsBar
                  id="specs-header-fixed"
                  style={{
                    position: 'fixed',
                    top: '56px',
                    visibility: 'hidden'
                  }}
                  items={review.acf.specifications}
                />
                <StickySpecsBar
                  id="specs-header"
                  items={review.acf.specifications}
                />
                <Specifications
                  specs={review.acf.specifications}
                  keySpecs={review.acf.key_specs}
                />
              </OuterBox>
            ) : null}

            {/* 3rd division */}
            <OuterBox>
              <InnerBox>
                <ListElement>
                  {/* Related Articles */}
                  {relatedArticles && relatedArticles.length ? (
                    <RelatedArticles relatedArticlesData={relatedArticles} />
                  ) : null}
                  {/* Tags */}
                  {tagsList && tagsList.length ? (
                    tagsList.map(tag => {
                      // console.log('tag: ', tag);
                      return (
                        <Link
                          key={tag.id}
                          style={{
                            textDecoration: 'none',
                            color: '#757575'
                          }}
                          to={`tags/${tag.tagSlug}`}
                        >
                          <FlexContainer
                            style={{
                              border: '1px solid #979797',
                              display: 'inline-flex',
                              padding: '0.5rem 1rem',
                              margin: '1rem 0.5rem'
                            }}
                          >
                            <Title
                              className="SubTitle"
                              fontFamily="Montserrat"
                              fontSize="0.875rem"
                              // padding="0"
                              fontStyle="italic"
                              lineheight="normal"
                              letterSpacing="0.3px"
                              color="#757575"
                              onClick={this.contentClickHandler}
                            >
                              {tag.tagTitle}
                            </Title>
                          </FlexContainer>
                        </Link>
                      );
                    })
                  ) : (
                    <Loader />
                  )}
                  {/* Comments */}
                  {review.user_meta.countNumber > 0 ? (
                    <Comments
                      commentData={{
                        count: review.user_meta.countNumber,
                        author: review._embedded.author,
                        comments: review._embedded.replies
                      }}
                    />
                  ) : null}
                </ListElement>
                <SideBar>
                  <div
                    width="100%"
                    height="100%"
                    style={{ visibility: 'hidden' }}
                  />
                </SideBar>
              </InnerBox>
            </OuterBox>
            <OuterBox>
              <InnerBox>
                <ListElement className="w-100" maxwidth="100%" padding="20px">
                  {/* <Title
                    fontFamily="Montserrat"
                    fontSize="1.5rem"
                    fontWeight="bold"
                  >
                    Suggested
                  </Title>
                  <StyledLine>
                    <StyledLineInside />
                  </StyledLine>
                  <AdBanner height="210px" width="1000px" margin="0" /> */}
                  <AdBanner height="346px" width="1040px" margin="0">
                    <Image
                      src={adSuggested}
                      width="100%"
                      height="100%"
                      alt="tissot ad"
                    />
                  </AdBanner>
                </ListElement>
              </InnerBox>
            </OuterBox>
          </div>
        );
      });
    } else {
      singlereview = <SingleArticleLoader />;
    }
    // singlereview = null;
    // return { singlereview };
    return (
      <Fragment>
        {/* <StickySpecsBar className="StickySpecsBar" /> */}
        <StickyHeader className="StickyHeader" />
        {singlereview}
        <div
          className="fixed dn bn outline-0 pointer"
          style={{ bottom: '18vh', right: '1rem' }}
          onClick={() => handleGoToTop()}
          id="goToTopBtn"
          title="Go to top"
        >
          <img src={goToTop} alt="goToTop" />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  // console.log('[Singlereview] state.singleReview: ', state.singleReview);
  return {
    // topNews: state.news.topNews,
    singleReview: state.singleReview.singleReview,
    relatedArticles: state.singleReview.relatedArticles,
    tagsList: state.singleReview.tagsList,
    error: state.singleReview.error,
    loading: state.singleReview.loading
  };
};

const mapDispatchToProps = dispatch => ({
  // onFetchSingleReview: (postSlug, timeStamp) =>
  //   dispatch(Creators.fetchSingleReview(postSlug, timeStamp)),
  onFetchSingleReview: postSlug =>
    dispatch(Creators.fetchSingleReview(postSlug)),
  onFetchTopNews: () => dispatch(Creators.fetchTopNews()),
  onFetchRelatedArticles: (tagId, postId) =>
    dispatch(Creators.fetchRelatedArticlesForSingleReview(tagId, postId))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SingleReview)
);
